import classNames from 'classnames';
import React from 'react';

import {TableEditableClass} from 'notebook/tables/core-ui/TableEditable';
import {TableIndex} from 'notebook/tables/TableConstants';
import {ElementMouseEvent} from 'util/Types';

export interface TableGhostCellProps {
  cid: string;
  i: number;
  j: number;
  expandToAndEditCell: (index: TableIndex, selectAll?: boolean) => void;
  cellMouseMoveHandler: TableEditableClass['fillDownMouseMoveHandler'];
  selectCell: TableEditableClass['selectCell'];
  isHeaderRow: boolean;
  isFillDownBoxLeftEdge: boolean;
  isFillDownBoxRightEdge: boolean;
  isFillDownBoxTopEdge: boolean;
  isFillDownBoxBottomEdge: boolean;
  isSelected: boolean;
}

export default class TableGhostCell extends React.PureComponent<TableGhostCellProps> {
  cellMouseMoveHandler = (): void => {
    this.props.cellMouseMoveHandler([this.props.i, this.props.j]);
  };

  dblClickHandler = (): void => {
    this.props.expandToAndEditCell([this.props.i, this.props.j]);
  };

  mouseDownHandler = (e: ElementMouseEvent): void => {
    e.preventDefault(); // Avoid stealing focus
    this.props.selectCell([this.props.i, this.props.j], {editing: false, collapse: true});
  };

  override render(): JSX.Element {
    return (
      <td
        className={classNames('cell', 'is-ghost-cell', {
          'header-cell': this.props.isHeaderRow,
          'dbl-selected': this.props.isSelected,
          selected: this.props.isSelected,
          'is-fillDownBox-leftEdge': this.props.isFillDownBoxLeftEdge,
          'is-fillDownBox-rightEdge': this.props.isFillDownBoxRightEdge,
          'is-fillDownBox-topEdge': this.props.isFillDownBoxTopEdge,
          'is-fillDownBox-bottomEdge': this.props.isFillDownBoxBottomEdge,
        })}
        // Must have cid here for the floating cell editor to find the position of this cell
        data-cid={this.props.cid}
        onDoubleClick={this.dblClickHandler}
        onMouseDown={this.mouseDownHandler}
        onMouseMove={this.cellMouseMoveHandler}
      >
        <div className="td-padding-fixer">
          <div data-cid={this.props.cid} className="editable" />
        </div>
      </td>
    );
  }
}
